import { FindMaterialPackResponseDto, UpdateMaterialPackRequestDto } from 'store/api/materialPacks'
import {
    MaterialPackAdditionalFields, MaterialPackAutocompleteFields,
    MaterialPackFormGlobal
} from './MaterialPack.types'
import {
    autocompleteChangeArg, autocompleteFieldDefault, autocompleteSubmitArg
} from 'utils/inputs.tsx';
import {
    AutocompleteSubmitData, InputChangeArg, InputSubmitArg
} from 'types/inputs.ts';
import {
    MaterialFormBodyPack
} from 'components/Resources/Materials/Materials.types.ts';


// *
// DATA CONVERT FUNCS
// *

export const convertMaterialPackDtoToFormGlobal = (pack: FindMaterialPackResponseDto & MaterialPackAdditionalFields): MaterialPackFormGlobal => ({
    ...pack,
    materialId: pack.materialId,
})

export const convertMaterialPackFormToRequestDto = (data: Partial<MaterialPackFormGlobal>): UpdateMaterialPackRequestDto & { id?: string } => ({
    id: data.id || materialPackFormGlobalInitialState.id,
    materialId: data.materialId || materialPackFormGlobalInitialState.materialId,
    default: data?.default || materialPackFormGlobalInitialState.default,
    packing: data?.packing || materialPackFormGlobalInitialState.packing,
    price: data?.price || materialPackFormGlobalInitialState.price,
    proportion: data?.proportion || materialPackFormGlobalInitialState.proportion,
    tradePrice: data?.tradePrice || materialPackFormGlobalInitialState.tradePrice,
    //unitMeasure: data?.unitMeasure || materialPackFormGlobalInitialState.unitMeasure,
    unitMeasure : data?.unitMeasure ? data.unitMeasure.data.name : ''
})


// *
// STORE
// *

export const materialPackFormGlobalInitialState: MaterialFormBodyPack = {
    id: 'new',
    materialId: 'new',
    default: false,
    packing: 1,
    price: 0,
    proportion: 0,
    tradePrice: 0,
    unitMeasure: autocompleteFieldDefault,
}


// *
// INPUTS PROCESSING
// *


export const onMaterialPackAutocompleteSubmit = ({ key, setFormValue }: InputSubmitArg<MaterialPackAutocompleteFields, MaterialFormBodyPack>) =>
    (data: AutocompleteSubmitData) => {
        setFormValue(key, autocompleteSubmitArg(data))
    }
export const onMaterialPackAutocompleteChange = ({ formData, key, setFormValue }: InputChangeArg<MaterialPackAutocompleteFields, MaterialFormBodyPack>) =>
    (label: string) => {
        if (formData[key]?.name !== label) {
            setFormValue(key, autocompleteChangeArg(label))
        }
    }

